module.exports = __webpack_public_path__ + "static/vidyard-logo-4d934ecb9b5791fd990a1d5cbd7fa1b2.jpeg";